import {range} from 'lodash'
import React from 'react'
import Text from 'react-text'
import {Link} from 'react-router-dom'
import Griddle, {plugins} from 'griddle-react'
import {Context, Consumer} from '../../../../context'
import {bind, enhancedWithRowData, get} from '../../../../helpers/utils'
import Label from '../../../label'
import {faUsers, faUser} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import ContextLoader from '../../../context-loader'
import {Pagination, PageDropdown} from '../../../pagination'
import './table.styl'

function Containerless (props) {
  const {TableBody} = props
  return (<TableBody />)
}

const CustomTableBody = ({ rowIds, Row, style, className }) => (
  <div style={style} className={className}>
    { rowIds && rowIds.map(r => <Row key={r} griddleKey={r} />) }
  </div>
)

const StudentRow = enhancedWithRowData(({rowData}) => {
  const {name, downloadCount, groups, studentId, fillerIndex} = rowData
  if (fillerIndex != undefined)
    return (<div className="filler" style={{width: 342}}/>)
  else
    return (
      <Consumer>{ (context) => {
        const groupId = context.groupId
        const query  = {page: undefined}
        return (
          <div className="student">
            <Link className="student-link"
              to={context.link(
                {studentId, groupId},
                '/:languageId/:role/:page/:groupId?/student/:studentId',
                {preserveQuery: true, query}
              )}
            >
              <div className="icon-wrapper">
                <div className="icon">
                  <FontAwesomeIcon icon={faUser} />
                </div>
              </div>
              <div className="label">
                <div className="name">
                  <Label value={name} maxLength={25} />
                </div>
                <div  className="count">
                  {downloadCount}{" "}<Text id={`download${downloadCount == 1 ? '' : 's'}_label`} />
                </div>
                <div className="groups">
                  <div className="label">
                    <Text id="groups_label" />:
                  </div>
                  <div className="value">
                    <Label value={groups.map(get('name')).join(', ')} maxLength={37} />
                  </div>
                </div>
              </div>
          </Link>
        </div>
    )}}</Consumer>)
})

function Filter (props) {
  return (<Consumer>{ context => {
    const [pageProperties, ...students] = context.studentsDownloadLog
    const group = context.groups.find(({id}) => id == context.groupId)
    const {recordCount} = pageProperties || {}
    return (
      <div className="info">
        {group && (
          <div className="group-name">
            <div className="icon">
              <FontAwesomeIcon icon={faUsers} />
            </div>
            <div className="name-wrapper">
              <div className="name">
                {group.name}
              </div>
            </div>
          </div>
        )}
        {recordCount !== undefined && (
          <div className="student-count">
            <div className="icon">
              <FontAwesomeIcon icon={faUser} />
            </div>
            <div className="count">
              {recordCount}{" "}<Text id={`student${recordCount == 1 ? '' : 's'}_label`} />
            </div>
          </div>
        )}
      </div>
    )}}</Consumer>)
}

const Layout = ({Table, Pagination, Filter}) => {
  return (
  <div className="students-download-log-table">
    <div className="head">
      <Filter />
      <div style={{flexGrow: 1}} />
      <Pagination />
    </div>
    <Table />
  </div>
  )
}

function NoResults (props) {
  return (
    <div className={props.className}>
      <Text id="catalog_search_no_results_label" />
    </div>
  )
}


export default class Students extends React.Component {
  static contextType = Context

  constructor(props) {
    super(props)
    bind(this, 'goPage', 'goNext', 'goPrevious')
  }

  goPage (page) {
    this.context.navigate({}, this.context.match.params, {preserveQuery: true, query:{page}})
  }

  goNext () {
    this.goPage(this.context.catalogueSearchResults[0].currentPage + 1)
  }

  goPrevious () {
    this.goPage(this.context.catalogueSearchResults[0].currentPage - 1)
  }

  render () {
    const context = this.context 
    const [pageProperties, ...students] = context.studentsDownloadLog

    const columnCount = Math.floor((context.sizes.width - 220) / 342) % 342
    const missingCount = students.length % columnCount
    const fillers = range(columnCount - missingCount).map(fillerIndex => ({fillerIndex}))
    const {recordCount} = pageProperties || {}
    return (
      <ContextLoader id="studentsDownloadLog" className="students-download-log">
        <Griddle
          className="students-download-log-results"
          data={students.concat(fillers)}
          components={{
            NoResults,
            PageDropdown,
            Filter,
            Pagination,
            Layout,
            Row: StudentRow,
            Table: Containerless,
            TableBody: CustomTableBody
          }}
          pageProperties={pageProperties}
          events={{
            onNext: this.goNext,
            onPrevious: this.goPrevious,
            onGetPage: this.goPage
          }}
        >
        </Griddle>
      </ContextLoader>)
  }
}
